import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Benefits from '../components/Benefits';

import Download from '../components/Download';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      document.getElementById(location.state.scrollTo)?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <Features />
      <Benefits />
      {/* <Quote /> */}
      <Download />
    </>
  );
};

export default HomePage;
